<template>
  <div id="echarts">
    <div id="myChart" class="line"></div>
  </div>
</template>
<script>
// 水印的函数
import { addWaterMarker } from "libs/common/common";
// 引入基本模板
import echarts from "echarts/lib/echarts";
// 引入拆线图组件
import "echarts/lib/chart/line";
// 引入提示框、legend和title组件
import "echarts/lib/component/tooltip";
// import "echarts/lib/component/title";
import "echarts/lib/component/legend";

export default {
  props: ['list'],
  data () {
    return {}
  },
  props: ['xData', 'yDataSame', 'yDataRing', 'thanTitle', 'thanTitle2'], //xData：x坐标 yDataSame：同比也是比上月 yDataRing：环比也是比上年
  watch: {
    xData () {
      this.drawLine(this.xData, this.yDataSame, this.yDataRing)
    }
  },
  mounted () {
    this.drawLine(this.xData, this.yDataSame, this.yDataRing)
    // let dom = document.getElementById('echarts')
    // addWaterMarker(dom,'当月新增4G客户')
  },
  methods: {
    drawLine (xData, yDataRing, yDataSame, ) {
      let self = this
      let showLastMonth = true,
        showLastYear = true // 是否展示 '比上月' 和比上年 的标志

      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.getElementById('myChart'))
      const option = {
        //提示框  
        tooltip: {
          // //触发类型：坐标轴触发  
          trigger: 'axis',
          // trigger: 'item',
          backgroundColor: 'rgba(255,255,255,1)', //通过设置rgba调节背景颜色与透明度  
          color: '#43484D',
          borderWidth: 1,
          borderRadius: 5,
          borderColor: '#eee',
          shadowColor: 'rgba(0, 0, 0, 0.5)',
          shadowBlur: 10,
          shadowOffsetY: 20,
          padding: 0,
          textStyle: {
            color: '#43484D',
          },
          position ([x, y]) { //提示框位置指定
            // console.log('x', x)
            // console.log('y', y)
            return [x - 55, y - 45]
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#9dcae9',
              width: 1,
              type: 'dashed'
            },
            crossStyle: {
              color: '#9dcae9',
              width: 1,
              type: 'dashed'
            },
            shadowStyle: {
              color: 'rgba(150,150,150,0.3)',
              width: 1,
              type: 'default'
            }
          },
          formatter (data) {
            const index = data[0].dataIndex
            let domData = ``
            let domSame = Number(yDataSame[index]) >= 0 ? "<font class='color-yellow'>" : "<font class='color-green'>"
            let domRing = Number(yDataRing[index]) >= 0 ? "<font class='color-yellow'>" : "<font class='color-green'>"
            if (showLastMonth && showLastYear) {
              domData = "<div class='tips'><div class='tips-top'> " + xData[index] + "</div> <br/> <div class='tips-content'>" + self.thanTitle + domRing + yDataRing[index] + "%</font> <br/>" + self.thanTitle2 + domSame + yDataSame[index] + "%</font></div></div>"

            } else if (showLastMonth) {
              domData = "<div class='tips'><div class='tips-top'> " + xData[index] + "</div> <br/> <div class='tips-content'>" + self.thanTitle + domRing + yDataRing[index] + "%</font> </div></div>"
            } else if (showLastYear) {
              domData = "<div class='tips'><div class='tips-top'> " + xData[index] + "</div> <br/> <div class='tips-content'>" + self.thanTitle2 + domSame + yDataSame[index] + "%</font></div></div>"
            }

            return domData //将小数转化为百分数显示,并自定义样式
          },
          // extraCssText:'background:rgba(0, 0, 0, 0.5);'  
        },
        color: [], //线条的主颜色
        legend: { //指标位置
          x: '55%',
          y: '5%',
          data: [] //['比上月', "比上年"]
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          boundaryGap: true, //xAxis中的boundaryGap属性，设置为false代表是零刻度开始，设置为true代表离零刻度间隔一段距离
          axisLabel: {
            interval: 0, //横轴信息全部显示 
            color: "#86939E" //刻度线标签颜色
          },
          axisTick: { //坐标轴刻度相关设置
            show: true, //是否显示坐标轴刻度。
            alignWithLabel: true, //类目轴中在 boundaryGap 为 true 的时候有效，可以保证刻度线和标签对齐
            interval: 'auto', //坐标轴刻度的显示间隔，在类目轴中有效。默认会采用标签不重叠的策略间隔显示标签。可以设置成 0 强制显示所有标签。如果设置为 1，表示『隔一个标签显示一个标签』，如果值为 2，表示隔两个标签显示一个标签，以此类推
            inside: true, //坐标轴刻度是否朝内，默认朝外。
            // length:5,                //坐标轴刻度的长度。
            // lineStyle:mylineStyle
          },
          axisLine: {
            lineStyle: {
              color: '#e2e2e2',
              width: 1, //这里是为了突出显示加上的  
            }
          },
          data: xData
        }],
        yAxis: [{
          type: 'value',
          splitLine: { // 控制网格线是否显示
            show: false
          },
          axisLabel: {
            color: "#86939E" //刻度线标签颜色
          },
          axisTick: { //坐标轴刻度相关设置
            show: true, //是否显示坐标轴刻度。
            alignWithLabel: true, //类目轴中在 boundaryGap 为 true 的时候有效，可以保证刻度线和标签对齐
            interval: 'auto', //坐标轴刻度的显示间隔，在类目轴中有效。默认会采用标签不重叠的策略间隔显示标签。可以设置成 0 强制显示所有标签。如果设置为 1，表示『隔一个标签显示一个标签』，如果值为 2，表示隔两个标签显示一个标签，以此类推
            inside: true, //坐标轴刻度是否朝内，默认朝外。
            // length:5,                //坐标轴刻度的长度。
            // lineStyle:mylineStyle
          },
          axisLine: {
            lineStyle: {
              color: '#e2e2e2',
              width: 1, //这里是为了突出显示加上的  
            }
          },
        }],
        series: [] //放每一项展示的数据的
      };

      let lastMonth = {
        name: this.thanTitle,
        type: 'line',
        // stack: '总量',
        //smooth : false,
        //symbol: null,         // 拐点图形类型
        symbolSize: 5, // 拐点图形大小
        //symbolRotate : null,  // 拐点图形旋转控制
        showAllSymbol: false, // 标志图形默认只有主轴显示（随主轴标签间隔隐藏策略）
        itemStyle: {
          normal: {
            // color: 各异,
            label: {
              show: false
              // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
              //           'inside'|'left'|'right'|'top'|'bottom'
              // textStyle: null      // 默认使用全局文本样式，详见TEXTSTYLE
            },
            lineStyle: {
              width: 2,
              type: 'solid',
              shadowColor: 'rgba(0,0,0,0)', //默认透明
              shadowBlur: 5,
              shadowOffsetX: 3,
              shadowOffsetY: 3
            }
          },
          emphasis: {
            // color: 各异,
            label: {
              show: false
              // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
              //           'inside'|'left'|'right'|'top'|'bottom'
              // textStyle: null      // 默认使用全局文本样式，详见TEXTSTYLE
            }
          }
        },
        data: yDataRing
      },
        lastYear = {
          name: this.thanTitle2,
          type: 'line',
          // stack: '总量',
          //smooth : false,
          //symbol: null,         // 拐点图形类型
          symbolSize: 5, // 拐点图形大小
          //symbolRotate : null,  // 拐点图形旋转控制
          showAllSymbol: false, // 标志图形默认只有主轴显示（随主轴标签间隔隐藏策略）
          itemStyle: {
            normal: {
              // color: 各异,
              label: {
                show: false
                // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
                //           'inside'|'left'|'right'|'top'|'bottom'
                // textStyle: null      // 默认使用全局文本样式，详见TEXTSTYLE
              },
              lineStyle: {
                width: 2,
                type: 'solid',
                shadowColor: 'rgba(0,0,0,0)', //默认透明
                shadowBlur: 5,
                shadowOffsetX: 3,
                shadowOffsetY: 3
              }
            },
            emphasis: {
              // color: 各异,
              label: {
                show: false
                // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
                //           'inside'|'left'|'right'|'top'|'bottom'
                // textStyle: null      // 默认使用全局文本样式，详见TEXTSTYLE
              }
            }
          },
          data: yDataSame
        }
      option.legend.data = []
      if (showLastMonth && showLastYear) { //'比上月', "比上年" 都展示
        option.series = [lastMonth, lastYear]
        option.legend.data = [self.thanTitle, self.thanTitle2]
        option.color = ["#0384df", "#86d8dd"]

      }
      option.legend.data = [self.thanTitle, self.thanTitle2]
      // 绘制图表
      myChart.setOption(option);
    }
  }
}

</script>
<style lang="less">
.line {
  height: 5.7rem;
  padding-left: 0.1rem;
  div:nth-child(2) {
    z-index: 999 !important;
  }
}

.tips {
  min-width: 1.7rem;
  max-width: 2rem;
  padding: 5px 10px;
  box-shadow: 6px 6px 5px #ccc;
}

.tips-content {
  font-family: 'PingFang-SC-Medium';
  color: #43484d;
  font-size: 0.25rem;
  margin-top: -15px;
}

.tips-top {
  color: #43484d;
  border-bottom: 1px solid #eaeaea;
  text-align: center;
}

.color-yellow {
  margin-left: 0.1rem;
  color: #fc9d2e;
}

.color-green {
  margin-left: 0.1rem;
  color: #269513;
}
</style>



// WEBPACK FOOTER //
// src/components/app/add/lineChart.vue